import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    copilotData: {
        requesting: false,
        error: null,
        success: false,
        message: '',
        results: null
    },
    chatData: {
        requesting: false,
        error: null,
        success: false,
        message: '',
        results: [
            {
                type: 'agent',
                data: {
                    message: "Hi! I'm Eli, your intelligent HR assistant. I can help you navigate HyvidOne, explain features, generate reports, or take you to any section. Just ask me where you want to go or what you need help with!",
                    timestamp: new Date(),
                }
            }
        ]
    },
  };

export const copilotSlice = createSlice({
  name: 'copilot',
  initialState,
  reducers: {
    doAskCopilot: (state, action) => {
        state.copilotData.requesting = true;
        state.copilotData.error = null;
        state.copilotData.success = false;
        state.copilotData.message = action.payload;
    },
    doAskCopilotSuccess: (state, action) => {
        console.log(action.payload);
        state.copilotData.requesting = false;        
        state.copilotData.results = action.payload;
        state.copilotData.success = true; 
    },
    doAskCopilotFail: (state, action) => {        
        state.copilotData.requesting = false;
        state.copilotData.error = action.payload;
    },
    doAgentChat: (state, action) => {
        state.chatData.requesting = true;
        state.chatData.error = null;
        state.chatData.success = false;
        state.chatData.message = action.payload;
        state.chatData.results.push({
            type: 'user',
            data: {
                ...action.payload,
                timestamp: new Date(),
            }
        });
    },
    doAgentChatSuccess: (state, action) => {
        console.log(action.payload);
        state.chatData.requesting = false;    
        state.chatData.results.push({
            type: 'agent',
            data: {
                ...action.payload,
                timestamp: new Date(),
            }
        });
        state.chatData.success = true; 
    },
    doAgentChatFail: (state, action) => {        
        state.chatData.requesting = false;
        state.chatData.error = action.payload;
        state.chatData.results.push({
            type: 'error',
            data: {
                ...action.payload,
                timestamp: new Date(),
            }
        });
    },
  },
})

export const { 
    doAskCopilot, doAskCopilotSuccess, doAskCopilotFail,
    doAgentChat, doAgentChatSuccess, doAgentChatFail,
} = copilotSlice.actions;

export default copilotSlice.reducer;
